// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"420":"054d234c","892":"41b1dd1c"}[chunkId] + ".css";
};